import React from 'react'
import { ESGVerificationDetailFormStyle } from './styled'
import {
  Button,
  Image,
  Input,
  Section,
  SelectBox,
  Switcher,
  InputTextarea,
} from '../../components'
import { ICONS } from '../../themes'

import { ROUTE_PATH, redirect, STRING } from '../../helpers'

export class ESGVerificationDetailFormContainer extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      isEditPageState: true,
    }
  }

  render() {
    const { isEditPageState } = this.state

    return (
      <ESGVerificationDetailFormStyle>
        {/* PAGE TITLE
        -----------------------------------------------------
        -----------------------------------------------------
        */}
        <Section className="page-topbar">
          <Section className="page-header">
            <Section className="page-icon">
              <Image
                id="page_icon_esg_verification"
                src={ICONS['icon-esg.svg']}
                alt="page icon"
              />
            </Section>

            <Section className="title-and-breadcrumb">
              <Section id="page_title_buyer_management" className="title">
                {STRING.ESG_VERIFICATION}
              </Section>

              <Section
                id="page_breadcrumb_buyer_management"
                className="breadcrumbs"
              >
                <Button
                  className="breadcrumb"
                  onClick={() => {
                    this.props.history.push(ROUTE_PATH.HOME.LINK)
                  }}
                >
                  <span>{STRING.HOME}</span>
                </Button>

                <Button
                  className="breadcrumb"
                  onClick={() => {
                    this.props.history.push(ROUTE_PATH.HOME.LINK)
                  }}
                >
                  <span>{STRING.ESG_VERIFICATION}</span>
                </Button>

                <Button className="breadcrumb current">
                  <span>Edit ESG Verification</span>
                </Button>
              </Section>
            </Section>
          </Section>
        </Section>

        {/* PAGE CONTENT
        -----------------------------------------------------
        -----------------------------------------------------
        */}
        <Section className="main-content form">
          <Section className="content-body">
            <Section className="form-wrapper">
              <Section className="form-group-title">
                Edit ESG Verification
              </Section>

              <Section className="info-wrapper">
                <Section className="detail-group">
                  <div className="label">TaxID:</div>

                  <div className="data-control">
                    <div className="data">3110203040123</div>
                  </div>
                </Section>

                <Section className="detail-group">
                  <div className="label">Company Name:</div>

                  <div className="data-control">
                    <div className="data">Test Company Name</div>
                  </div>
                </Section>

                <Section className="detail-group">
                  <div className="label">Business Group:</div>

                  <div className="data-control">
                    <div className="data">Food & Beverage</div>
                  </div>
                </Section>

                <Section className="detail-group">
                  <div className="label">Email:</div>

                  <div className="data-control">
                    <div className="data">redbull@mail.com</div>
                  </div>
                </Section>

                <Section className="detail-group">
                  <div className="label">Phone:</div>

                  <div className="data-control">
                    <div className="data">089-123-4567</div>
                  </div>
                </Section>
              </Section>

              <Section className="form-group-header small-bottom-space">
                ESG
              </Section>

              <Section className="form-group is-error">
                <label>Environmental Score</label>

                <Section className="form-group-control">
                  <Section className="form-group-inner-wrapper">
                    <Input type="text" className="score" value="" />
                  </Section>

                  <Section className="message">error</Section>
                </Section>
              </Section>

              <Section className="form-group">
                <label>Social Score</label>

                <Section className="form-group-control">
                  <Section className="form-group-inner-wrapper">
                    <Input type="text" className="score" value="9.47" />
                  </Section>

                  <Section className="message">error</Section>
                </Section>
              </Section>

              <Section className="form-group">
                <label>Governance Score</label>

                <Section className="form-group-control">
                  <Section className="form-group-inner-wrapper">
                    <Input type="text" className="score" value="9.47" />
                  </Section>

                  <Section className="message">error</Section>
                </Section>
              </Section>

              <Section className="form-group">
                <label>ESG Score</label>

                <Section className="form-group-control">
                  <Section className="form-group-inner-wrapper">
                    <Input type="text" className="score" value="9.47" />
                  </Section>

                  <Section className="message">error</Section>
                </Section>
              </Section>
            </Section>

            <Section className="form-actions">
              <Button className="theme-border-gray">Cancel</Button>

              <Button className="theme-green">Save</Button>
            </Section>
          </Section>
        </Section>
      </ESGVerificationDetailFormStyle>
    )
  }
}
